module.exports = __webpack_public_path__ + "img/generation_orange.d023c9d3.png";